import Popup from '@/common/Popup';
import { PopupTypes } from '@/common/Popup/types';
import PotentialTripsForm from './PotentialTripsForm';

export interface PotentialTripsDrawerProps extends PopupTypes.Props {
  providerId?: string;
  importId?: string;
  onRefresh?: () => void;
}

const PotentialTripsDrawer = ({ providerId, importId, onRefresh, onHide, ...drawerProps }: PotentialTripsDrawerProps) => {
  return (
    <Popup {...drawerProps} className="PotentialTripsDrawer" onHide={onHide} title="Create Potential Trip">
      <PotentialTripsForm value={{ providerId, importId }} onClose={onHide} onRefresh={onRefresh} />
    </Popup>
  );
};

export default PotentialTripsDrawer;
